import { Box, Typography } from "@mui/material";
import { ACCENTS, COLORS, rise } from "./emsTheme";

/** The title row every EMS V2 page starts with: gradient icon tile, title, one-line purpose,
 *  and optional actions on the right (they wrap under the title on phones). */
const EmsPageHeader = ({ icon: Icon, title, sub, actions }) => (
    <Box sx={{ mb: 2.5, display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap", ...rise(0) }}>
        <Box sx={{ width: 48, height: 48, borderRadius: "12px", flexShrink: 0, background: ACCENTS.purple.grad,
            boxShadow: `0 6px 16px ${COLORS.purple}40`, display: "grid", placeItems: "center" }} aria-hidden>
            {Icon && <Icon sx={{ color: "#fff", fontSize: 26 }} />}
        </Box>
        <Box sx={{ flex: "1 1 240px", minWidth: 0 }}>
            <Typography component="h1" sx={{ fontSize: 22, fontWeight: 800, color: COLORS.ink, lineHeight: 1.3, letterSpacing: "-.01em" }}>{title}</Typography>
            {sub && <Typography sx={{ fontSize: 14, color: COLORS.ink2 }}>{sub}</Typography>}
        </Box>
        {actions && <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>{actions}</Box>}
    </Box>
);

export default EmsPageHeader;
